<div class="container-fluid cw-background">
  <mat-card class="mat-elevation-z8 mt-3 mb-5">
    <mat-card-title class="title-page">Assets List</mat-card-title>
    <button
      *ngIf="currentUser.hasRight(['admin', 'manager'])"
      mat-fab
      class="create"
      color="accent"
      (click)="onAddAsset()"
    >
      <mat-icon>add</mat-icon>
    </button>
    <mat-card-content class="mt-12">
      <app-data-table
        #table
        *ngIf="tableConfig"
        [config]="tableConfig"
        (getData)="assetTableService.getAssets($event)"
        (updateData)="assetTableService.updateAsset($event)"
      >
        <ng-template #customHeader let-context>
          <!-- Selection Action -->
          <div class="row custom-header" *ngIf="currentUser.hasRight(['admin', 'manager'])">
            <div class="col-md-3">
              <mat-form-field class="field-selector" appearance="fill">
                <mat-label>Select an action</mat-label>
                <mat-select (selectionChange)="selectedAction = field.value" #field>
                  <mat-option value="">--</mat-option>
                  <mat-option *ngFor="let action of assetActions" [value]="action">
                    {{ action.label | titlecase }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field class="field-selector" appearance="fill">
                <input
                  type="text"
                  required
                  matInput
                  placeholder="Additional Information"
                  [(ngModel)]="additionalInformation"
                  value="{{ additionalInformation }}"
                />
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <button
                class="btn btn-primary send-action-btn"
                [disabled]="
                  {
                    selectedAction: selectedAction,
                    additionalInformation: additionalInformation,
                    selectedRows: table?.config?.selection?.selectedRows
                  } | applyFunctionOrReturn: isSendActionEnabled
                "
                (click)="onSendAction()"
              >
                Send
              </button>
            </div>
          </div>
        </ng-template>
      </app-data-table>
    </mat-card-content>
  </mat-card>
</div>
